<template>
  <rb-loader v-model="loadingData" :contained="true"></rb-loader>
  <div class="tab-content w-100 d-flex justify-space-between align-start">
    <div class="full-width-tab-content-text d-flex flex-column ga-8">
      <v-text-field
        v-show="false"
        ref="validationField"
        v-model="validationStatus"
        :rules="inputRules.required"
        required
      />
      <div
        class="config-group d-flex flex-column"
      >
        <h2 class="mb-2 title-medium">Interesses</h2>
        <p class="body-medium">
          Defina os Interesses que dinamicamente o assistente utilizará nas
          conversas e referências.
        </p>
      </div>
      <v-divider class="w-100"></v-divider>
      <div class="config-group d-flex flex-column">
        <div class="d-flex align-center ga-2">
          <h2 class="mb-2 title-medium">Condições</h2>
          <v-chip
            class="mb-2"
            v-if="!validationStatus"
            prepend-icon="mdi-alert-circle"
            size="small"
            color="alert-system-dark"
          >
            <b>Alterações não salvas</b>
          </v-chip>
        </div>
        <p class="body-medium">
          Escolha condições específicas em que apenas os interesses com aquelas
          características sejam escolhidos.
        </p>
        <div class="d-flex ga-4">
          <v-btn
            @click="openMenu"
            prepend-icon="mdi-plus"
            rounded="pill"
            variant="text"
            color="primary-35"
            :loading="loadingContexts"
            class="condition-add-button px-6 py-5 d-flex"
          >
            Adicionar nova condição
            <ContextMenu
              v-model="menuOpen"
              v-model:data="localData.conditions"
              v-model:update-data="updateConditions"
              v-model:loading-status="loadingContexts"
              :selected-context="selectedContext"
              :selected-entity="selectedEntity"
              :selected-condition="selectedCondition"
              @clearSelectionProps="clearSelectionProps"
            ></ContextMenu>
          </v-btn>
        </div>
        <div
          v-if="localData.conditions.length > 0"
          class="chips-container d-flex ga-1 justify-start flex-wrap"
        >
          <div
            v-for="(context, contextIndex) in localData.conditions"
            :key="context.contextoId"
            class="w-100 d-flex flex-column mb-3"
          >
            <div class="d-flex align-center justify-space-between mb-2">
              <h3 class="chip-context">{{ context.contextoTitulo }}</h3>
            </div>
            <div class="d-flex flex-row ga-4">
              <div
                v-for="(entity, entityIndex) in context.entidades"
                :key="entity.entidadeId"
                class="d-flex"
              >
                <v-chip
                  :class="{ 'chip-disabled': chipDisabled }"
                  @click="openSelectedMenu(context, entity, condition)"
                  v-for="(condition, conditionIndex) in entity.dados"
                  :key="conditionIndex"
                  variant="outlined"
                  color="neutral-35"
                  class="condition-chips d-flex ga-2 py-1 px-2 mr-2 mb-1"
                >
                  <div
                    class="chip-text-content"
                    ref="chipText"
                    @mouseenter="checkOverflow($event, `${contextIndex}-${entityIndex}-${conditionIndex}`)"
                  >
                    {{ getChipContent(entity, condition) }}
                  </div>
                  <v-icon
                    icon="mdi-close"
                    @click="removeCondition(contextIndex, entityIndex, conditionIndex)"
                  ></v-icon>
                  <v-tooltip
                    v-model="overflows[`${contextIndex}-${entityIndex}-${conditionIndex}`]"
                    :disabled="!overflows[`${contextIndex}-${entityIndex}-${conditionIndex}`]"
                    activator="parent"
                    location="top"
                  >
                    <span
                      v-html="getChipContent(entity, condition, true)"
                    ></span>
                  </v-tooltip>
                </v-chip>
              </div>
              <v-chip
                :class="{ 'chip-disabled': chipDisabled }"
                prepend-icon="mdi-trash-can-outline"
                variant="outlined"
                color="neutral-35"
                @click="clearContextConditions(contextIndex)"
                class="clear-chip d-flex py-1 px-2"
                size="small"
              >
                Limpar tudo
              </v-chip>
            </div>
          </div>
        </div>
      </div>
      <div
        class="include-registrations-buttons-container d-flex justify-end ga-4 py-3"
      >
        <v-btn
          class="px-6 py-5 d-flex"
          color="neutral-35"
          @click="discardChanges"
          rounded="xl"
          variant="outlined"
          style="border-color: rgb(var(--v-theme-neutral-60))"
          prepend-icon="mdi-close-circle-outline"
          :disabled="!hasFilterChanges"
          >Desfazer alterações</v-btn
        >
        <v-btn
          class="px-6 py-5 d-flex"
          color="primary-35"
          @click="updatePreview"
          rounded="xl"
          variant="outlined"
          style="border-color: rgb(var(--v-theme-neutral-60))"
          prepend-icon="mdi-cached"
          :loading="loadingPreviewButton"
          >Atualizar pré-visualização</v-btn
        >
        <v-btn
          class="px-6 py-5 d-flex"
          color="primary-60"
          @click="saveChanges"
          rounded="xl"
          :disabled="!hasFilterChanges"
          >Salvar alterações</v-btn
        >
      </div>
      <div
        class="config-group d-flex flex-column ga-3 w-100"
      >
        <div class="d-flex align-center ga-2">
          <h2 class="title-medium">Pré-visualização de dados</h2>
        </div>
        <div class="d-flex flex-column ga-4"></div>
      </div>
      <div v-if="!validateDataTable" class="conditions-table-empty">
        <div class="conditions-table-empty__table-text" v-if="!loadingDataTable">
          <h3>Nenhum dado encontrado.</h3>
          <p>Experimente adicionar condições.</p>
        </div>
        <v-data-table
          hide-no-data
        ></v-data-table>
      </div>
      <div v-else-if="validateDataTable" class="conditions-table-view">
        <v-tabs v-model="tabContext" color="primary-60">
          <div v-for="context in dataTable" :key="context.id">
            <v-tab
              v-if="context.items.length || loadingDataTable"
              :value="context.id"
              >{{ context.title }}</v-tab
            >
          </div>
        </v-tabs>
        <v-window v-model="tabContext">
          <v-window-item
            v-for="context in dataTable"
            :key="context.id"
            :value="context.id"
          >
            <div
              class="d-flex justify-content-between align-center ma-4 flex-1-0"
            >
              <div class="d-flex flex-column ga-4">
                <v-chip
                  v-if="localData.outOfSync && selectedOffers.length > 0"
                  prepend-icon="mdi-alert-circle"
                  size="small"
                  color="alert-system-dark"
                  style="max-width: 280px"
                >
                  <b>Marcações não correspondem as condições</b>
                </v-chip>
                <div class="d-flex align-center ga-2">
                  <p>
                    {{ selectedOffers.length }}/{{ totalOffers }} Interesses selecionados
                  </p>
                  <div
                    v-if="selectedOffers.length > 1000"
                    style="color: #7e0007; font-style: italic; font-weight: 600"
                  >
                    Limite de interesses alcançado (1.000)
                  </div>
                </div>
              </div>

              <rb-input
                style="margin-left: auto; max-width: 320px"
                prepend-inner-icon="mdi-magnify"
                v-model="search"
                placeholder="Pesquisar"
                clearable
                hide-details
              ></rb-input>
            </div>
            <div
              class="ma-4"
              style="border: 1px solid #e1e3e2; border-radius: 8px"
            >
              <v-data-table
                :headers="enhancedHeaders(context.headers)"
                :items="context.items"
                :search="search"
                :loading="loadingDataTable"
                :header-props="{ style: 'background-color: #f5f5f5;' }"
                item-value="_internal_unique_key"
              >
                <template #[`header.select`]>
                  <v-checkbox
                    density="compact"
                    :model-value="areAllSelected(context)"
                    :indeterminate="areSomeSelected(context)"
                    @update:model-value="toggleAll(context, $event)"
                    hide-details
                  />
                </template>
                <template #[`item.select`]="{ item }">
                  <v-checkbox
                    density="compact"
                    :model-value="isSelected(item)"
                    @update:model-value="v => toggleSelect(item, v)"
                    hide-details
                  />
                </template>
                <template
                  v-for="header in standardTableHeaders"
                  :key="header"
                  v-slot:[`item.${header}`]="{ value }"
                >
                  {{ value || '--' }}
                </template>
                <template v-slot:loading>
                  <v-skeleton-loader type="table-row@5"></v-skeleton-loader>
                  <rb-loader v-model="loadingDataTable" contained />
                </template>
                <template v-slot:no-data>
                  <div class="conditions-table-empty">
                    <div class="pa-8">
                      <h3>Nenhum dado encontrado.</h3>
                      <p>Experimente adicionar condições.</p>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-window-item>
        </v-window>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch, onMounted } from 'vue';
import { useSnackbarStore } from '@/ai_studio/stores/snackbar';
import ContextMenu from '@/assistents/components/ContextMenu/ContextMenu.vue';
import { fetchContextos, contextData, request } from '@/ai_studio/utils/fetchData';
import { structureTableHeaders } from '@/ai_studio/utils/dataStructure';
import { useRoute } from 'vue-router';
import RbLoader from '@/ai_studio/components/common/RbLoader.vue';

const snackbar = useSnackbarStore();
const standardTableHeaders = ['codigo', 'curso', 'nivel_ensino', 'modalidade', 'local_oferta', 'processo_seletivo', 'oferta_curso'];

const menuOpen = ref(false);
const search = ref('');
const overflows = ref({});
const loadingContexts = ref(false);
const updateConditions = ref(false);
const dataTable = ref([]);
const tabContext = ref(null);
const loadingPreviewButton = ref(false);
const validationField = ref(null);
const loadingDataTable = ref(false);
const route = useRoute();
const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: { type: Object, required: true },
  inputRules: { type: Object, required: true },
});
const selectedContext = ref({});
const selectedEntity = ref({});
const selectedCondition = ref({});
const chipDisabled = ref(false);
const selectedOffers = ref([]);
const savedConditions = ref([]);
const savedCourseOffers = ref([]);
const selectedOfferKeys = ref(new Set());

const isEditing = computed(() => route.path !== '/assistentes/create');

const loadingDataValue = ref(isEditing.value);

const loadingData = computed({
  get: () => loadingDataValue.value,
  set: (newValue) => { loadingDataValue.value = newValue; }
});

const hasSelections = computed(() => localData.value.conditions.length > 0);

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => { emit('update:modelValue', newValue); }
});

const hasFilterChanges = computed(() => {
  return JSON.stringify(localData.value.conditions) !== JSON.stringify(savedConditions.value);
});

const validationStatus = computed(() => !hasFilterChanges.value ? 'valid' : '');

const totalOffers = computed(() => {
  return dataTable.value.reduce((sum, context) => sum + context.items.length, 0);
});

const validateDataTable = computed(() => {
  return dataTable.value.some(context => context.items.length > 0) || loadingDataTable.value;
});

const openMenu = () => {
  chipDisabled.value = true;
  menuOpen.value = true;
  loadingContexts.value = true;
};

const openSelectedMenu = (context, entity, condition) => {
  if (chipDisabled.value) return;
  chipDisabled.value = true;
  selectedContext.value = context;
  selectedEntity.value = entity;
  selectedCondition.value = condition;
  openMenu();
};

const clearSelectionProps = () => {
  selectedContext.value = {};
  selectedEntity.value = {};
  selectedCondition.value = {};
  chipDisabled.value = false;
};

const getChipContent = (entity, condition, html = false) => {
  const emptyConditions = ['NAO_VAZIO', 'VAZIO'];
  if (!condition.dados.length && !condition.todos && !emptyConditions.includes(condition.codigo)) return '';
  const arrow = !html && !emptyConditions.includes(condition.codigo) ? ' > ' : '';
  const prefix = `${entity.entidadeTitulo}: ${condition.titulo}${arrow}`;
  if (condition.todos) return prefix + 'Todos';

  const maxItems = 3;
  const items = condition.dados.slice(0, maxItems).map(item => {
    const text = item.codigo ? `${item.codigo} - ${item.titulo ?? item.nome}` : item.titulo ?? item.nome;
    return html ? `<br> <span>${text}</span>` : text;
  });

  let result = prefix + items.join(', ');
  if (html && condition.dados.length > maxItems) result += `<br> <span> + ${condition.dados.length - maxItems} outros </span>`;
  return result;
};

const checkOverflow = (event, conditionKey) => {
  const element = event.target;
  overflows.value[conditionKey] = element.scrollWidth > element.clientWidth;
};

const removeCondition = (contextIndex, entityIndex, conditionIndex) => {
  const context = localData.value.conditions[contextIndex];
  const entity = context.entidades[entityIndex];
  entity.dados.splice(conditionIndex, 1);
  if (entity.dados.length === 0) {
    context.entidades.splice(entityIndex, 1);
    if (context.entidades.length === 0) {
      localData.value.conditions.splice(contextIndex, 1);
    }
  }
  updateConditions.value = true;
  localData.value.outOfSync = true;
};

const clearContextConditions = (contextIndex) => {
  if (chipDisabled.value) return;
  localData.value.conditions.splice(contextIndex, 1);
  updateConditions.value = true;
  localData.value.outOfSync = true;
};

const enhancedHeaders = (headers) => [
  { key: 'select', title: '', align: 'start', sortable: false, width: '40px' },
  ...headers
];

const offerKey = (item) => item._internal_unique_key;

const isSelected = (item) => selectedOfferKeys.value.has(offerKey(item));

const toggleSelect = (item, value) => {
  const key = offerKey(item);
  if (value) {
    selectedOffers.value.push(item);
    selectedOfferKeys.value.add(key);
  } else {
    selectedOffers.value = selectedOffers.value.filter(o => offerKey(o) !== key);
    selectedOfferKeys.value.delete(key);
  }
};

const filterItems = (context, searchValue) => {
  if (!searchValue) return context.items;
  const lowerSearch = searchValue.toLowerCase();
  const searchableKeys = context.headers.map(h => h.key);
  return context.items.filter(item =>
    searchableKeys.some(key => {
      const value = item[key];
      return value != null && String(value).toLowerCase().includes(lowerSearch);
    })
  );
};

const areAllSelected = (context) => {
  const filtered = filterItems(context, search.value);
  return filtered.length > 0 && filtered.every(item => isSelected(item));
};

const areSomeSelected = (context) => {
  const filtered = filterItems(context, search.value);
  const selectedCount = filtered.filter(item => isSelected(item)).length;
  return selectedCount > 0 && selectedCount < filtered.length;
};

const toggleAll = (context, value) => {
  const filtered = filterItems(context, search.value);
  const itemsToToggle = value
    ? filtered.filter(item => !isSelected(item))
    : filtered.filter(item => isSelected(item));

  if (itemsToToggle.length === 0) return;

  if (value) {
    selectedOffers.value = [...selectedOffers.value, ...itemsToToggle];
    itemsToToggle.forEach(item => selectedOfferKeys.value.add(offerKey(item)));
  } else {
    const keysToRemove = new Set(itemsToToggle.map(offerKey));
    selectedOffers.value = selectedOffers.value.filter(o => !keysToRemove.has(offerKey(o)));
    keysToRemove.forEach(key => selectedOfferKeys.value.delete(key));
  }
};

const loadPreview = async (clearSelected = false) => {
  try {
    if (clearSelected) {
      selectedOffers.value = [];
      selectedOfferKeys.value.clear();
    }
    localData.value.outOfSync = false;

    if (localData.value.conditions.length === 0) {
      dataTable.value = [];
      return;
    }
    if (!contextData.value && localData.value.conditions.length) {
      await fetchContextos();
    }
    dataTable.value = structureDataTable(contextData.value.filter(ctx => localData.value.conditions.find(ct => ct.contextoId === ctx.id)));

    loadingDataTable.value = true;

    const filters = { conditions: localData.value.conditions };
    const response = await request('/api/assistents/crm/filterConditions', null, 'POST', JSON.stringify(filters));
    populateTable(response);
    setFirstTab();
    loadingDataTable.value = false;
  } catch (err) {
    console.error(err);
    snackbar.error('Não foi possível atualizar a pré-visualização.');
    loadingDataTable.value = false;
  }
};

const updatePreview = async (showSnackbar = true) => {
  loadingPreviewButton.value = true;
  await loadPreview(true);
  loadingPreviewButton.value = false;
  if (showSnackbar) snackbar.success('Pré-visualização atualizada com sucesso.');
};

const structureDataTable = (contexts) => {
  return contexts.map(contexto => ({
    id: contexto.contextoId || contexto.id,
    title: contexto.contextoTitulo || contexto.titulo,
    headers: structureTableHeaders(contexto),
    items: []
  }));
};

const populateTable = (data) => {
  for (let key in data) {
    const context = dataTable.value.find(item => item.id == key);
    if (context) {
      context.items = data[key].map((item, index) => ({
        ...item,
        _internal_unique_key: `${key}-${item.id || 'item'}-${index}` 
      }));
    }
  }
};

const setFirstTab = () => {
  if (dataTable.value.length) {
    const firstWithData = dataTable.value.find(item => item.items.length);
    if (firstWithData) tabContext.value = firstWithData.id;
  }
};

const discardChanges = () => {
  localData.value.conditions = structuredClone(savedConditions.value);
  snackbar.success('Alterações descartadas');
  localData.value.outOfSync = true;
};

const saveChanges = () => {
  localData.value.saved = structuredClone(localData.value.conditions);
  savedConditions.value = structuredClone(localData.value.conditions);
  localData.value.changed = true;
  snackbar.success('Condições salvas com sucesso.');
  localData.value.outOfSync = true;
};

const renderOffers = async () => {
  const { loading, conditions, courseOffers } = localData.value;

  if (loading) return;

  if (conditions.length === 0) return;

  localData.value.changed = conditions.length && !courseOffers?.length;

  try {
    loadingDataTable.value = true;
    await loadPreview(false);
    selectedOffers.value = structuredClone(courseOffers || []);
    selectedOfferKeys.value = new Set(selectedOffers.value.map(offerKey));
  } catch (err) {
    console.error(err);
  } finally {
    loadingDataTable.value = false;
  }
};

watch(validationStatus, () => {
  if (validationField.value) {
    validationField.value.resetValidation();
    validationField.value.validate();
  }
});

watch(selectedOffers, () => {
  localData.value.courseOffers = structuredClone(selectedOffers.value);
}, { deep: true });

watch(() => localData.value.conditions, (value) => {
  if (JSON.stringify(value) !== JSON.stringify(savedConditions.value)) {
    localData.value.changed = true;
    localData.value.outOfSync = true;
  }
}, { deep: true });

watch(() => localData.value.loading, async (isLoading) => {
  const { conditions } = localData.value;

  if (!conditions.length) {
    loadingData.value = false;
    return;
  }

  if (isLoading) return;

  try {
    if (conditions.length && !contextData.value) {
      await fetchContextos();
    }

    loadingData.value = false;
    await renderOffers();
  } catch (err) {
    console.error(err);
  }
});

onMounted(async () => {
  try {
    savedConditions.value = structuredClone(localData.value.saved || []);
    savedCourseOffers.value = structuredClone(localData.value.courseOffers || []);
    localData.value.outOfSync = localData.value.outOfSync ?? false;
    if (!localData.value.conditions.length) {
      loadingData.value = false;
      return;
    }
    if (hasSelections.value && !contextData.value) await fetchContextos();
    if (hasSelections.value && !localData.value.loading) await renderOffers();
  } catch (err) {
    console.error(err);
  } finally {
    loadingData.value = false;
  }
});
</script>

<style lang="scss" scoped>
@use "@/ai_studio/styles/components/assistents-configuration.scss";

.chip-disabled {
  cursor: default !important;
  pointer-events: none;
}

.chip-context {
  font-family: Roboto;
  font-size: 14px;
  color: rgb(var(--v-theme-neutral-35));
  font-weight: 600;
  letter-spacing: 0.25px;
  line-height: 20px;
}

.config-group {
  max-width: 800px;
}

.condition-add-button {
  width: fit-content !important;
}

.conditions-chip-container {
  width: fit-content;
}

.condition-chips {
  max-width: 280px;
  position: relative;
  border-radius: 8px;
  border: none;
  background-color: rgb(var(--v-theme-neutral-95));
}

.clear-chip {
  width: fit-content !important;
  min-width: 110px;
  position: relative;
  border-radius: 8px;
  border: 1px solid rgb(var(--v-theme-neutral-80));
}

.clear-chip:deep(.v-chip__content) {
  width: 100%;
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.clear-chip:deep(.v-chip__prepend i) {
  margin-right: 8px;
  color: #4c607b;
}

.clear-chip:deep(.chip-text-content) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.condition-chips:deep(.v-chip__content) {
  max-width: 100%;
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.condition-chips:deep(.v-chip__content i) {
  margin-left: 8px;
}

.condition-chips:deep(.chip-text-content) {
  color: #4c607b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.conditions-table-view {
  border: 1px solid rgb(var(--v-theme-neutral-80));
  border-radius: 8px;
}

.conditions-table-empty {
  & {
    text-align: center;
  }

  &__table-text {
    padding: 24px;
  }
}
</style>
